import React from 'react';
import { PageTemplate } from 'components/templates/PageTemplate';
import { config } from 'pages/config';
import { IPageBuilderConfig } from 'models/route';
import { Layout } from 'components/templates/Layout';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';
import { AxiosInterceptor } from 'utils/apiClient';
import { AuthProvider } from 'state/contexts/auth';
import { AlertProvider } from 'state/contexts/alert';
import { PasswordProvider } from 'state/contexts/password';
import { DictionaryProvider } from 'state/contexts/dictionary';
import { GlobalPropertyProvider } from 'state/contexts/globalProperty';
import { AccountProvider } from 'state/contexts/account';

export const history = createBrowserHistory();

const App = () => (
  <HistoryRouter history={history as any}>
    <AuthProvider>
      <AccountProvider>
        <PasswordProvider>
          <DictionaryProvider>
            <AlertProvider>
              <AxiosInterceptor />
              <GlobalPropertyProvider>
                <Layout>
                  <PageTemplate config={config as IPageBuilderConfig[]} />
                </Layout>
              </GlobalPropertyProvider>
            </AlertProvider>
          </DictionaryProvider>
        </PasswordProvider>
      </AccountProvider>
    </AuthProvider>
  </HistoryRouter>
);
export default App;
